import EnrollmentDatasetPropertyField from 'automation-ui-action-features/actions/extension/generic-extension/EnrollmentDatasetPropertyField';
import EnrollmentEventPropertyField from 'automation-ui-action-features/actions/extension/generic-extension/EnrollmentEventPropertyField';
import FetchedObjectPropertyField from 'automation-ui-action-features/actions/extension/generic-extension/FetchedObjectPropertyField';
import FieldDataField from 'automation-ui-action-features/actions/extension/generic-extension/FieldDataField';
import PropertyField from 'automation-ui-action-features/actions/extension/generic-extension/PropertyField';
import { ACTION_OUTPUTS, ENROLLED_OBJECT } from 'automation-ui-formula-editor/data-sources/constants/dataSourcesConstants';
import getTokenParts from 'automation-ui-formula-editor/data-sources/utils/getTokenParts';
const convertFieldDataToDataToken = genericActionField => {
  const {
    fieldValue
  } = genericActionField;
  if (!fieldValue) return '';
  if (fieldValue instanceof FieldDataField) {
    const {
      actionId,
      dataKey
    } = fieldValue.fieldDataIdentifier || {};
    const rawToken = `${ACTION_OUTPUTS}.action_output_${actionId}.${dataKey}`;
    return getTokenParts(rawToken).formattedToken;
  }
  if (fieldValue instanceof EnrollmentDatasetPropertyField || fieldValue instanceof EnrollmentEventPropertyField || fieldValue instanceof FetchedObjectPropertyField) {
    return getTokenParts(fieldValue.propertyToken).formattedToken;
  }
  if (fieldValue instanceof PropertyField) {
    const {
      propertyName
    } = fieldValue;
    const rawToken = propertyName ? `${ENROLLED_OBJECT}.${propertyName}` : '';
    return getTokenParts(rawToken).formattedToken;
  }
  const maybeString = fieldValue.getValue();
  return typeof maybeString === 'string' ? maybeString : '';
};
export default convertFieldDataToDataToken;